import React from "react";
import Sideform from "../../Sideform";
import ShareButtons from "../../../../utility/ShareButtons";
import FAQAccordion from "../../../../utility/FAQAccordion";
import QuickNavigation from "../../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../../utility/serviceTemplateutility/CardDesigntwo";
import WhyUs from "../../../../utility/serviceTemplateutility/WhyUs";
import Slider from "react-slick";
import CheckList from "../../../../utility/serviceTemplateutility/CheckList";
import OurTeam from "../../../homepage/OurTeam";
import Testimonials from "../../../homepage/Testimonials";
import { useGlobalData } from "../../../../contextApi/globalContextData";
import { useCart } from "../../../../contextApi/cartContext";
import MultiStepForm from "../../../../utility/serviceTemplateutility/MultiStepForm";
export default function MounjaroWeightLoss() {
  const serviceUrl = window.location.href;
  const { sectionsData } = useGlobalData();
  const { addToCart } = useCart();

  const product = {
    id: 1,
    title: "Mounjaro Injection in Dubai",
    price: 2499,
    description:
      "Mounjaro Injection in Dubai offers effective, non-surgical fat reduction with visible results and minimal downtime for targeted body contouring",
  };
  const faqs = [
    { heading: "Frequently Asked Questions" },
    {
      question: "Can you get Mounjaro in the UAE?",
      answer:
        "Yes, Mounjaro (tirzepatide) is available in the UAE for managing type 2 diabetes and aiding weight loss.",
    },
    {
      question: "How much weight can you lose on Mounjaro in a month?",
      answer:
        "Clinical trials suggest an average weight loss of about 4% of body weight after one month on Mounjaro.",
    },
    {
      question: "Can I buy Mounjaro over the counter?",
      answer:
        "No, Mounjaro is a prescription medication and cannot be purchased over the counter.",
    },
    {
      question: "What is the best injection for weight loss in the UAE?",
      answer:
        "Mounjaro (tirzepatide) is considered one of the most effective weight loss injections available in the UAE.",
    },
  ];

  const mounjaroProcedureSteps = [
    { heading: "Easy 4 Steps for Mounjaro Procedure" },
    {
      para: "The Mounjaro Weight Loss Injections works by targeting specific hormones in the body that control blood sugar and appetite. Here’s an overview of how the procedure works:",
    },
    {
      title: "Initial Evaluation",
      description:
        "Your journey starts with a consultation and health assessment, including a Body Composition Analysis (BCA) and blood tests to determine your suitability for Mounjaro.",
      icon: "fa-solid fa-user-md",
      link: "https://elitebodyhome.com/blood-test-at-home-dubai/",
    },
    {
      title: "Personalized Treatment Plan",
      description:
        "We create a tailored treatment plan based on your evaluation, including the appropriate Mounjaro dosage, typically administered subcutaneously once a week.",
      icon: "fa-solid fa-calendar-check",
    },
    {
      title: "Injection Process",
      description:
        "Our specialists administer the injection in a quick, minimally uncomfortable procedure, ensuring your comfort.",
      icon: "fa-solid fa-syringe",
    },
    {
      title: "Follow-Up Appointments",
      description:
        "Follow-up visits ensure you're progressing towards your goals, with adjustments to your treatment plan as needed.",
      icon: "fa-solid fa-calendar-day",
    },
  ];

  const mounjaroBenefits = [
    {
      title: "Significant Weight Loss",
      description:
        "Mounjaro can help individuals lose 15–20% of their body weight over several months.",
      icon: "fa-solid fa-weight-scale",
    },
    {
      title: "Effective Blood Sugar Control",
      description:
        "Improves insulin secretion and reduces blood sugar levels, lowering HbA1c.",
      icon: "fa-solid fa-syringe",
    },
    {
      title: "Cardiovascular Health",
      description:
        "May reduce the risk of cardiovascular events in people with type 2 diabetes.",
      icon: "fa-solid fa-heart-pulse",
    },
    {
      title: "Enhanced Satiety",
      description:
        "Promotes feelings of fullness, helping control hunger and supporting weight loss.",
      icon: "fa-solid fa-utensils",
    },
    {
      title: "Convenient Dosing",
      description:
        "Administered once weekly, making it easier for patients to stay on track.",
      icon: "fa-solid fa-calendar-week",
    },
    {
      title: "Potential Additional Benefits",
      description:
        "Shows promising results for non-alcoholic fatty liver disease and sleep apnea.",
      icon: "fa-solid fa-star",
    },
  ];

  const images = [
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/WEIGHT-LOSS-3.jpg",
      alt: "weight loss injections",
    },
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/WEIGHT-LOSS-1.jpg",
      alt: "weight loss dubai",
    },
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/02/Before-After-Service-Images-1wd.png",
      alt: "Before & After Service Images",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 992, // tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576, // mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const eligibilitycheckList = [
    {
      text: " Have a history of pancreatitis or other gastrointestinal issues.",
    },
    {
      text: "Have a history of diabetic retinopathy (eye problems related to diabetes)",
    },
    {
      text: "Have or have had thyroid problems, including thyroid cancer or a family history of thyroid cancer. ",
    },
    {
      text: " Have a history of allergic reactions to medications, especially GLP-1 or GIP receptor agonists.",
    },
    { text: " Are pregnant, planning to become pregnant, or breastfeeding." },
    {
      text: "Are taking other medications, including over-the-counter drugs and supplements",
    },
    {
      text: "Have a history of severe gastrointestinal conditions or other medical conditions that may affect your treatment.",
    },
  ];

  return (
    <>
      <title>
        Mounjaro Injection in Dubai | Weight Loss &amp; Diabetes Treatment
      </title>
      <meta
        name="description"
        content="Mounjaro Injection in Dubai: Get FDA-Approved Mounjaro Injection for Type 2 Diabetes &amp; Weight Loss (Off-Label) â€“ Available at Elite Body Home, Free Consultation."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/mounjaro-injection/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Mounjaro Injection in Dubai | Weight Loss &amp; Diabetes Treatment"
      />
      <meta
        property="og:description"
        content="Mounjaro Injection in Dubai: Get FDA-Approved Mounjaro Injection for Type 2 Diabetes &amp; Weight Loss (Off-Label) â€“ Available at Elite Body Home, Free Consultation."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/mounjaro-injection/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-21T17:29:44+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Mounjaro-Dubai.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Mounjaro-Dubai.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Mounjaro Dubai" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta
        property="og:video"
        content="https://www.youtube.com/embed/4E0Qa92FLpM"
      />
      <meta property="video:duration" content="28" />
      <meta property="ya:ovs:upload_date" content="2024-09-20T09:28:28-07:00" />
      <meta property="ya:ovs:allow_embed" content="true" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Mounjaro Injection in Dubai | Weight Loss &amp; Diabetes Treatment"
      />
      <meta
        name="twitter:description"
        content="Mounjaro Injection in Dubai: Get FDA-Approved Mounjaro Injection for Type 2 Diabetes &amp; Weight Loss (Off-Label) â€“ Available at Elite Body Home, Free Consultation."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Mounjaro-Dubai.jpg"
      />

      <div className="min-vh-100 font-sans text-dark mb-5 mx-3">
        <div className="container-fluid px-0 py-4">
          <div className="row justify-content-center">
            <div>
              <div
                className="rounded-4 overflow-hidden shadow-sm"
                style={{  border: "2px solid #c69933", }}
              >
                <div className="row g-0 align-items-stretch">
                  {/* Image Column - Left Side */}
                  <div className="col-lg-6">
                    <img
                      loading="lazy"
                      decoding="async"
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bannwar-large.png"
                      className="img-fluid w-100 h-100 object-fit-cover"
                      alt="Aqualyx fat dissolving injections in Dubai | Elite Body Home"
                      style={{
                        minHeight: "400px",
                        maxHeight: "720px",
                      }}
                    />
                  </div>

                  {/* Content Column - Right Side */}
                  <div className="col-lg-6 d-flex align-items-center bg-white">
                    <div
                      className="p-4 p-md-5 w-100"
                      style={{ maxWidth: "600px", margin: "0 auto" }}
                    >
                      <h1
                        className="display-5 fw-bold mb-3"
                        style={{
                          color: "#c69933",
                        }}
                      >
                        Mounjaro Injection in Dubai
                      </h1>
                      <p className="fs-5 text-secondary mb-4">
                        <ul>
                          <li>
                            Mounjaro FDA approved for Type 2 Diabetes Treatment
                          </li>
                          <li>Mounjaro Weight Loss Injection in Dubai</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Services
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Mounjaro Injection in Dubai
                </li>
              </ol>
            </nav>
            <QuickNavigation />
            <div>
              <p>
                At Elite Body Home Polyclinic in Dubai, our team of medical
                expert provide comprehensive consultations on the use of
                Mounjaro Injection. While renowned for its revolutionary effects
                on managing type 2 diabetes, Mounjaro has also gained widespread
                attention for its remarkable benefits in weight loss, making it
                a highly sought-after treatment for overall wellness and
                metabolic health. With personalized care and proven results, we
                ensure a safe and effective treatment tailored to your
                individual needs.
              </p>
            </div>

            <div>
              <h2 className="elementor-heading-title elementor-size-default">
                About Mounjaro Injection - Quick Facts:
              </h2>
            </div>
            <div>
              <ul>
                <li>
                  <strong>Cost:</strong> Starting price range between 1,999 AED
                  &#8211; 4,299 AED
                </li>
                <li>
                  <strong>Downtime:</strong> Minimal
                </li>
                <li>
                  <strong>Gender:</strong> Both male and female
                </li>
                <li>
                  <strong>Age: </strong>Applicable for 18+
                </li>
                <li>
                  <strong>Type of Procedure:</strong> Injectable
                </li>
                <li>
                  <strong>Ideal Candidate:</strong> Candidates with type 2
                  diabetes.
                </li>
                <li>
                  <strong>Results:</strong> Enhanced blood sugar level.
                </li>
                <li>
                  <strong>Treatment Duration:</strong> Continuing- as prescribed
                  by the doctors.
                </li>
                <li>
                  <strong>Frequency of Injection:</strong> Once a week, or a
                  prescribed.
                </li>
                <li>
                  <strong>Dosage:</strong> Start with a lower dose and adjust as
                  per the guidance of the doctor.
                </li>
              </ul>
            </div>

            <div className="container py-5" id="what">
              {/* Section Header */}
              <div className="row justify-content-center mb-4 mb-lg-5">
                <div className="col-lg-10 text-center">
                  <h2 className="title mb-3">What is Mounjaro Injection?</h2>
                </div>
              </div>

              {/* Content Row */}
              <div className="row align-items-center g-4 g-lg-5">
                {/* Image Column */}
                <div className="col-lg-5">
                  <div className="rounded-4 overflow-hidden shadow-lg">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/mon-inj-large.jpg"
                      alt="Mounjaro Injection for diabetes treatment"
                      className="img-fluid w-100"
                      loading="lazy"
                      style={{ objectFit: "cover", minHeight: "400px" }}
                    />
                  </div>
                </div>

                {/* Text Column */}
                <div className="col-lg-7">
                  <div className="ps-lg-4">
                    <p className="lead mb-4">
                      Mounjaro <span className="fw-bold">(tirzepatide)</span> is
                      an FDA-approved prescription medication available in
                      strengths of{" "}
                      <span className="badge bg-primary bg-opacity-10 text-primary fs-6 fw-normal me-1">
                        2.5 mg
                      </span>
                      <span className="badge bg-primary bg-opacity-10 text-primary fs-6 fw-normal me-1">
                        5 mg
                      </span>
                      <span className="badge bg-primary bg-opacity-10 text-primary fs-6 fw-normal me-1">
                        7.5 mg
                      </span>
                      <span className="badge bg-primary bg-opacity-10 text-primary fs-6 fw-normal me-1">
                        10 mg
                      </span>
                      <span className="badge bg-primary bg-opacity-10 text-primary fs-6 fw-normal me-1">
                        12.5 mg
                      </span>
                      <span className="badge bg-primary bg-opacity-10 text-primary fs-6 fw-normal">
                        15 mg
                      </span>{" "}
                      per 0.5 mL injection.
                    </p>

                    <div className="bg-light p-4 rounded-3 mb-4">
                      <p className="mb-0">
                        <i className="fas fa-info-circle text-primary me-2"></i>
                        Used in adults above 18 with type 2 diabetes, alongside
                        diet and exercise, to improve blood sugar (glucose)
                        control.
                      </p>
                    </div>

                    <p>
                      This groundbreaking treatment is the first and only
                      medication that targets both{" "}
                      <span className="fw-bold">
                        GIP (glucose-dependent insulinotropic polypeptide)
                      </span>{" "}
                      and{" "}
                      <span className="fw-bold">
                        GLP-1 (glucagon-like peptide-1)
                      </span>{" "}
                      receptors.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="container py-5" id="how">
              {/* Section Header */}
              <div className="row justify-content-center mb-4 mb-lg-5">
                <div className="col-lg-10 text-center">
                  <h2 className="title">How Mounjaro Helps With Weight Loss</h2>
                  <p className="lead text-muted">
                    Mounjaro (tirzepatide) is an injectable medication that
                    works through multiple mechanisms, making it a powerful tool
                    for weight loss.
                  </p>
                </div>
              </div>

              {/* Content Row */}
              <div className="row align-items-center g-4 g-lg-5">
                {/* Image Column */}
                <div className="col-lg-5 order-lg-2">
                  <div className="rounded-4 overflow-hidden shadow-lg">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/monj-large.jpg"
                      alt="Mounjaro weight loss injection mechanism"
                      className="img-fluid w-100"
                      loading="lazy"
                      style={{
                        objectFit: "cover",
                        minHeight: "400px",
                        maxHeight: "500px",
                      }}
                    />
                  </div>
                </div>

                {/* Benefits Column */}
                <div className="col-lg-7 order-lg-1">
                  <div className="pe-lg-4">
                    <div className="d-flex align-items-start mb-4">
                      <div className="me-3 mt-1 ">
                        <i className="fas fa-utensils fa-lg"></i>
                      </div>
                      <div>
                        <h4 className="h5 fw-bold mb-2">
                          Hunger Control & Minimal Cravings
                        </h4>
                        <p className="mb-0">
                          Mounjaro reduces hunger and cravings, making it easier
                          to eat less without feeling deprived.
                        </p>
                      </div>
                    </div>

                    <div className="d-flex align-items-start mb-4">
                      <div className="me-3 mt-1 ">
                        <i className="fas fa-hourglass-half fa-lg"></i>
                      </div>
                      <div>
                        <h4 className="h5 fw-bold mb-2">Slows Digestion</h4>
                        <p className="mb-0">
                          Helps you stay full longer by slowing stomach
                          emptying, naturally lowering calorie intake.
                        </p>
                      </div>
                    </div>

                    <div className="d-flex align-items-start mb-4">
                      <div className="me-3 mt-1 ">
                        <i className="fas fa-fire fa-lg"></i>
                      </div>
                      <div>
                        <h4 className="h5 fw-bold mb-2">
                          Boosts Metabolism & Fat Burning
                        </h4>
                        <p className="mb-0">
                          Activates GLP-1 & GIP hormones to improve fat burning
                          and food processing.
                        </p>
                      </div>
                    </div>

                    <div className="d-flex align-items-start">
                      <div className="me-3 mt-1 ">
                        <i className="fas fa-chart-line fa-lg"></i>
                      </div>
                      <div>
                        <h4 className="h5 fw-bold mb-2">
                          Balances Blood Sugar
                        </h4>
                        <p className="mb-0">
                          Stabilizes blood sugar to prevent energy crashes and
                          unhealthy cravings.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="procedures">
              <CardDesign carditems={mounjaroProcedureSteps} />
            </div>
            <div className="container my-5">
              <div className="row">
                <div className="col-12">
                  <h2 className="text-center title">
                    How Much Weight Can You Lose with Mounjaro?
                  </h2>
                </div>
              </div>
              <div className="text-center">
                <p>
                  Studies show that individuals who used the highest dose of
                  Mounjaro,
                  <b>15 milligrams, were able to lose up to 21%</b> of their
                  body weight, showcasing its effectiveness in weight
                  management.
                </p>
              </div>

              <div className="row text-center">
                <div className="mx-auto">
                  <img
                    loading="lazy"
                    decoding="async"
                    width="50%"
                    height="auto"
                    src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/mon-large.jpg"
                    alt="Mounjaro Weight Loss Injection in Dubai"
                    className="img-fluid border rounded"
                  />
                </div>
              </div>
            </div>

            <div
              className="elementor-element elementor-element-083fb67 e-con-full e-flex e-con e-child"
              data-id="083fb67"
              data-element_type="container"
              id="price"
            >
              <div
                className="elementor-element elementor-element-11fd596 elementor-widget elementor-widget-heading"
                data-id="11fd596"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <h2 className="elementor-heading-title elementor-size-default">
                  What is the Cost of Mounjaro in Dubai?
                </h2>
              </div>
              <div
                className="elementor-element elementor-element-5e973e8 elementor-widget elementor-widget-text-editor"
                data-id="5e973e8"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <p>
                  The cost of Mounjaro injections in Dubai ranges from{" "}
                  <strong>1,999 AED to 4,299 AED,</strong> depending on the
                  dosage and type, such as{" "}
                  <strong>Mounjaro 2.5mg or 7.5mg</strong>. At{" "}
                  <a
                    href="https://elitebodyhome.com/"
                    target="_blank"
                    rel="noopener"
                  >
                    Elite Body Home
                  </a>
                  , we offer a customized weight loss package, including a
                  tailored diet plan from one of the{" "}
                  <a
                    href="https://elitebodyhome.com/best-dietician-in-dubai/"
                    target="_blank"
                    rel="noopener"
                  >
                    best dietitians in Dubai
                  </a>
                  .
                </p>
                <h4>
                  <strong>Our Mounjaro Package Includes:</strong>
                </h4>
                <p>
                  ✔ 4 Weight Loss Injections
                  <br />✔ 2 EMS Sessions + 2 Water Retention Treatments
                  <br />✔ Dietitian Follow-Up
                  <br />✔ Fitness Assessment
                  <br />✔ Vital Check-Up
                </p>
                <p>
                  <em>
                    <strong>
                      We recommend booking a FREE consultation to receive a
                      personalized treatment plan and detailed pricing.
                    </strong>
                  </em>
                </p>
              </div>
            </div>

            <div class="container my-5" id="benefits">
              <div class="row mb-4">
                <div class="col-12 text-center">
                  <h2 class="title">
                    Benefits of Mounjaro Injection for Weight Loss
                  </h2>
                </div>
              </div>

              <div class="row justify-content-center mb-4">
                <div class="col-md-6 text-center">
                  <img
                    src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/weight-loss-large.jpg"
                    alt="Mounjaro in Dubai"
                    class="img-fluid rounded shadow"
                  />
                </div>
              </div>

              <CardDesign carditems={mounjaroBenefits} />
            </div>

            <div className="container" id="results">
              <h2 className="title mb-4">
                Expected Results from Mounjaro Injections
              </h2>
              <Slider {...settings}>
                {images.map((img, index) => (
                  <div key={index} className="px-3">
                    <img src={img.src} alt={img.alt} className="img-fluid" />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="mt-4">
              <div>
                <h2 className="title">
                  Mounjaro Side Effects &amp; Restrictions
                </h2>
              </div>
              <div>
                <h4>
                  <strong>Mounjaro Common Side Effects:</strong>
                </h4>
                <ul>
                  <li>Nausea</li>
                  <li>Vomiting</li>
                  <li>Diarrhea</li>
                  <li>Decreased appetite</li>
                  <li>Constipation</li>
                  <li>Abdominal discomfort</li>
                </ul>
                <p>
                  These effects are usually mild and improve over time as your
                  body adjusts to the medication.
                </p>
                <h4>
                  <strong>Mounjaro Serious Side Effects (Rare):</strong>
                </h4>
                <ul>
                  <li>
                    Severe allergic reactions (rash, swelling, difficulty
                    breathing)
                  </li>
                  <li>
                    Pancreatitis (severe stomach pain that may radiate to your
                    back)
                  </li>
                  <li>
                    Low blood sugar (dizziness, sweating, shakiness) when used
                    with other diabetes medications
                  </li>
                  <li>Gallbladder issues</li>
                </ul>
                <h4>
                  <strong>Mounjaro Restrictions:</strong>
                </h4>
                <ul>
                  <li>
                    Not for individuals with type 1 diabetes or diabetic
                    ketoacidosis.
                  </li>
                  <li>
                    Avoid if you or your family have a history of medullary
                    thyroid carcinoma or MEN 2.
                  </li>
                  <li>
                    Not recommended for those with severe gastrointestinal
                    disorders like gastroparesis.
                  </li>
                  <li>
                    Consult our doctor by{" "}
                    <a
                      href="https://elitebodyhome.com/services/doctor-on-call-dubai/"
                      target="_blank"
                      rel="noopener"
                    >
                      doctor on call
                    </a>{" "}
                    if pregnant or breastfeeding, as safety is not established.
                  </li>
                </ul>
              </div>
            </div>

            <div id="eligibility">
              <CheckList
                items={eligibilitycheckList}
                title=" Before Using Mounjaro, Inform Your Healthcare Provider if You:"
              />
            </div>

            <div className="container my-4">
              <div
                className="card border-0 shadow-sm rounded-3 overflow-hidden"
                style={{ maxWidth: "380px", margin: "auto" }}
                itemScope
              >
                {/* Optimized Image */}
                <img
                  src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bannwar-large.png"
                  alt="Mounjaro Injection in Dubai"
                  className="card-img-top"
                  style={{ height: "220px", objectFit: "cover" }}
                  itemProp="image"
                  loading="lazy"
                />

                <div className="card-body px-3 py-3 text-center">
                  {/* Product Title */}
                  <h2
                    className="h5 fw-bold mb-2 text-dark"
                    itemProp="name"
                    style={{ lineHeight: "1.3" }}
                  >
                    Mounjaro Injection in Dubai
                  </h2>

                  {/* Compact Description */}
                  <p
                    className="text-muted small mb-3"
                    itemProp="description"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Mounjaro Injection in Dubai offers effective, non-surgical
                    fat reduction with visible results and minimal downtime for
                    targeted body contouring
                  </p>

                  {/* Price Section */}
                  <div className="mb-3" itemProp="offers" itemScope>
                    <span
                      className="text-success fw-bold"
                      style={{ fontSize: "1.05rem" }}
                    >
                      {/* <span itemProp="price">AED 2499</span> */}
                      <meta itemProp="priceCurrency" content="AED" />
                    </span>
                  </div>

                  {/* CTA Button */}
                  <button
                    className="btn rounded-pill px-3 py-1 text-white"
                    style={{
                      backgroundColor: "#c69933",
                      border: "2px solid #c69933",
                      fontSize: "0.9rem",
                    }}
                    onClick={() => addToCart(product)}
                    aria-label="Book Aqualyx treatment"
                  >
                    Add to Cart
                  </button>
                </div>

                {/* Hidden SEO Data */}
                <meta itemProp="brand" content="Elite Body Home" />
                <meta itemProp="sku" content="AQX-001" />
              </div>
            </div>

            <WhyUs language="en" />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials data={sectionsData["Success Stories"]} />
            <FAQAccordion faqData={faqs} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
}
